import apiClient from '@/services/rest-api-sms/apiClient'

const baseEndpoint = '/sync-iccid-log'

export const get = async (queryParam) => {
  const params = {
    page: queryParam?.page || undefined,
    limit: queryParam?.limit || undefined,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
  }

  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}`,
    params,
  })

  return response?.data
}
